/** SMS short link codes are always 10 characters. */
export const SMS_SHORT_LINK_CODE_LENGTH = 10;

/** Stand-in code for SMS previews, as long as a real SMS short link code. */
export const SMS_SHORT_LINK_PREVIEW_CODE = "a1b2c3d4e5";

export interface LinkShortenerSettings {
  linkShortenerSubdomain?: string | null;
  linkShortenerOmitProtocol?: boolean | null;
}

/** Drops `https://` from a short link for teams saving SMS characters. */
export function formatSmsShortLink(
  url: string,
  omitProtocol: boolean | null | undefined,
): string {
  return omitProtocol ? url.replace(/^https:\/\//, "") : url;
}

/** A short link as the team's SMS recipients would see it, for previews and length estimates. */
export function getShortenedLinkPreviewUrl(
  settings: LinkShortenerSettings | null | undefined,
  code: string,
): string {
  const host = settings?.linkShortenerSubdomain
    ? `${settings.linkShortenerSubdomain}.redo.link`
    : "redo.link";
  return formatSmsShortLink(
    `https://${host}/${code}`,
    settings?.linkShortenerOmitProtocol,
  );
}
